/**
 * A regra do filtro de período dos miolos.
 *
 * Papel: decide se uma data cai dentro de um período "de / até", como a origem
 * de Manutenções decide (`inDateRange`, l. 818–824).
 *
 * Como usar: os limites são o `value` cru dos campos de data — texto vazio ou
 * `AAAA-MM-DD` —, e a data do registro, texto ISO ou `null`. Comparar texto ISO
 * basta porque cada parte tem largura fixa. Com qualquer limite preenchido, o
 * registro sem data fica de fora: é o comportamento da origem, e é o que faz uma
 * corretiva sem "última atualização" sumir assim que alguém filtra por período.
 */

/**
 * Diz se uma data está no período.
 *
 * @param data - A data do registro, `AAAA-MM-DD`, ou `null` quando não há.
 * @param de - O limite inicial, `''` quando vazio. Inclusivo.
 * @param ate - O limite final, `''` quando vazio. Inclusivo.
 * @returns `true` sem limite nenhum; com limite, `true` só para data presente e
 *   dentro dele.
 */
export function dentroDoPeriodo(data: string | null, de: string, ate: string): boolean {
  if (de === '' && ate === '') return true;
  if (data === null || data === '') return false;
  if (de !== '' && data < de) return false;
  if (ate !== '' && data > ate) return false;
  return true;
}
